import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a6f1a42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "clubEvents" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "display-2 center mb-4" }, "Klubarrangementer", -1))
const _hoisted_3 = { class: "eventContainer" }
const _hoisted_4 = { class: "layout gutter--lg" }
const _hoisted_5 = { class: "row justify--space-around align--center" }
const _hoisted_6 = { class: "flex md4 xs12 sm6" }
const _hoisted_7 = { class: "flex md4 xs12 sm6" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Opret nyt klubarrangement")
const _hoisted_9 = { class: "va-table-responsive" }
const _hoisted_10 = {
  class: "va-table va-table--hoverable eventTable",
  style: {"width":"100%"}
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Titel"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Sidste tilmelding"),
    /*#__PURE__*/_createElementVNode("th", null, "Afholdes"),
    /*#__PURE__*/_createElementVNode("th", null, "Muligheder")
  ])
], -1))
const _hoisted_12 = { class: "capitalize" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Vis/ Rediger")
const _hoisted_14 = { class: "display-4 center" }
const _hoisted_15 = { class: "eventInfoContainer layout gutter--lg" }
const _hoisted_16 = { class: "row align--center justify--center" }
const _hoisted_17 = { class: "flex md12" }
const _hoisted_18 = { class: "flex md8" }
const _hoisted_19 = { class: "flex md4" }
const _hoisted_20 = { class: "flex md4" }
const _hoisted_21 = { class: "flex md4" }
const _hoisted_22 = { class: "flex md4" }
const _hoisted_23 = { class: "flex md12" }
const _hoisted_24 = { class: "flex md6" }
const _hoisted_25 = { class: "flex md6" }
const _hoisted_26 = {
  key: 0,
  class: "flex md4",
  style: {"display":"flex"}
}
const _hoisted_27 = ["href"]
const _hoisted_28 = { class: "flex md6" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "center" }, [
      /*#__PURE__*/_createElementVNode("i", null, "* Feltet er obligatorisk")
    ]),
    /*#__PURE__*/_createElementVNode("p", { class: "center" }, [
      /*#__PURE__*/_createElementVNode("i", null, "** Hvis ikke andet er angivet, så er sidste tilmeldelsesfrist den samme som starttidspunktet")
    ])
  ])
], -1))
const _hoisted_30 = { class: "row justify--center" }
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Annuller")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_file_upload = _resolveComponent("va-file-upload")!
  const _component_va_form = _resolveComponent("va-form")!
  const _component_it_modal = _resolveComponent("it-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_va_select, {
              modelValue: _ctx.filterByTimeValue,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterByTimeValue) = $event)),
              options: _ctx.filterByTimeOptions,
              bordered: "",
              label: "Arrangement Status"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_va_button, {
              color: "success",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.newEvent()))
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_va_divider),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("table", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clubEvents, (event, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, _toDisplayString(event.event_titel), 1),
                  _createElementVNode("td", null, _toDisplayString((event.event_sidstetilmelding === null ? _ctx.danishDateString(event.event_start) : _ctx.danishDateString(event.event_sidstetilmelding))), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.beingHeld(event.event_start, event.event_slut)), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_va_button, {
                      size: "small",
                      class: "btn",
                      color: "info",
                      rounded: false,
                      onClick: ($event: any) => (_ctx.editClubEvent(event.id))
                    }, {
                      default: _withCtx(() => [
                        _hoisted_13
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.clubEventsModal,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.clubEventsModal) = $event)),
      width: "50%"
    }, {
      header: _withCtx(() => [
        _createElementVNode("h4", _hoisted_14, _toDisplayString(_ctx.clubEventData.title), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_va_form, {
            ref: "form",
            onValidation: _cache[12] || (_cache[12] = ($event: any) => (_ctx.validation = $event))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_va_input, {
                    modelValue: _ctx.clubEventData.title,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.clubEventData.title) = $event)),
                    label: "Titel*",
                    type: "text",
                    bordered: "",
                    rules: [(v) => v.length > 1 || 'Klubarrangementet mangler en titel']
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_va_input, {
                    modelValue: _ctx.clubEventData.location,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.clubEventData.location) = $event)),
                    label: "Sted *",
                    type: "text",
                    bordered: "",
                    rules: [(v) => v.length > 1 || 'Klubarrangementet mangler en adresse']
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_va_input, {
                    modelValue: _ctx.clubEventData.price,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.clubEventData.price) = $event)),
                    label: "Pris",
                    type: "number",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_va_input, {
                    type: "date",
                    modelValue: _ctx.clubEventData.registrationDeadline,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.clubEventData.registrationDeadline) = $event)),
                    label: "Sidste tilmeldingsfrist **",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_va_input, {
                    type: "datetime-local",
                    modelValue: _ctx.clubEventData.start,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.clubEventData.start) = $event)),
                    label: "Starttidspunkt *",
                    bordered: "",
                    rules: [(v) => v.length === 16 || 'Klubarrangmentet mangler et starttidspunkt' ]
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_va_input, {
                    type: "datetime-local",
                    modelValue: _ctx.clubEventData.end,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.clubEventData.end) = $event)),
                    label: "Sluttidspunkt *",
                    bordered: "",
                    rules: [(v) => v.length === 16 || 'Klubarrangmentet mangler et sluttidspunkt']
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_va_input, {
                    modelValue: _ctx.clubEventData.description,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.clubEventData.description) = $event)),
                    label: "Beskrivelse",
                    type: "textarea",
                    rows: 5,
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_va_input, {
                    modelValue: _ctx.clubEventData.extraContactEmail,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.clubEventData.extraContactEmail) = $event)),
                    label: "Tilmelding Email",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_va_input, {
                    modelValue: _ctx.clubEventData.extraContactTelephone,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.clubEventData.extraContactTelephone) = $event)),
                    label: "Tilmelding Telefon",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ]),
                ((_ctx.clubEventData.invitation !== null && _ctx.clubEventData.invitation.length > 0))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("p", null, [
                        _createElementVNode("a", {
                          href: _ctx.defaultURL + _ctx.clubEventData.invitation[0]?.url,
                          target: "_blank"
                        }, _toDisplayString(_ctx.clubEventData.invitation[0]?.name), 9, _hoisted_27)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_28, [
                  _createVNode(_component_va_file_upload, {
                    "file-types": ".pdf",
                    dropzone: "",
                    type: "single",
                    modelValue: _ctx.uploadInvitation,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.uploadInvitation) = $event))
                  }, null, 8, ["modelValue"])
                ])
              ])
            ]),
            _: 1
          }, 512),
          _hoisted_29
        ])
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_va_button, {
            class: "mr-4",
            color: "success",
            onClick: _cache[13] || (_cache[13] = ($event: any) => {_ctx.$refs.form.validate(); (_ctx.createNewEvent ? _ctx.createNewClubEvent() : _ctx.updateEvent(_ctx.clubEventData.id))})
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.createNewEvent ? 'Opret nyt klubarrangement' : 'Opdater'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_va_button, {
            class: "ml-4",
            color: "secondary",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.clubEventsModal = false))
          }, {
            default: _withCtx(() => [
              _hoisted_31
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}